import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ebenchLogo from "../../images/ebench_logo.png";
import { useDispatch } from "react-redux";
import { register, VendorRegister } from "../../Redux/action/AuthAction";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
// import { isValidPhoneNumber } from "libphonenumber-js/max";
import { SpinLoader } from "../Vendor/ImportCandidates";
import "./Registration.css";
import { motion } from "framer-motion";
import logo from "../../images/ebench_logo.png";

const Registration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirm_password: "",
    aadhaar: "",
    userType: "CANDIDATE",
  });

  const [phoneNumber, setPhoneNumber] = useState("");
  const [localPhone, setLocalPhone] = useState(""); // stripped number (for DB)

  const [countryCode, setCountryCode] = useState("");
  const [dialCode, setDialCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const [countryID, setCountryID] = useState([
    { countryName: "Select Country", Id: "ID", Length: "N/A" },
    { countryName: "India", Id: "Aadhaar Card", Length: 12 },
    { countryName: "USA", Id: "SSN", Length: 9 },
    { countryName: "UK", Id: "NIN", Length: 9 },
    { countryName: "Canada", Id: "SIN", Length: 9 },
    { countryName: "Australia", Id: "TFN", Length: 9 },
  ]);

  const [selectedCountry, setSelectedCountry] = useState(countryID[0]);
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await fetch(
          "https://countriesnow.space/api/v0.1/countries"
        );
        const data = await res.json();

        if (data && data.data) {
          const formatted = data.data.map((country) => {
            let idType = "Federal ID";
            let idLength = 12;
            switch (country.country) {
              case "India":
                idType = "Aadhaar Card";
                idLength = 12;
                break;
              case "USA":
                idType = "SSN";
                idLength = 9;
                break;
              case "UK":
                idType = "NIN";
                idLength = 9;
                break;
              case "Canada":
                idType = "SIN";
                idLength = 9;
                break;
              case "Australia":
                idType = "TFN";
                idLength = 9;
                break;
              default:
                idType = "Federal ID";
                idLength = 12;
            }

            return {
              countryName: country.country,
              Id: idType,
              Length: idLength,
            };
          });
          setCountryID([
            { countryName: "Select Country", Id: "ID", Length: "N/A" },
            ...formatted,
          ]);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (
      (name === "firstName" || name === "lastName") &&
      !/^[A-Za-z\s]*$/.test(value)
    ) {
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = (form) => {
    const errors = {};

    // First Name (min 2, max 30 chars)
    if (!form.firstName.trim()) {
      errors.firstName = "First name is required";
    } else if (form.firstName.length < 2) {
      errors.firstName = "First name must be at least 2 characters";
    } else if (form.firstName.length > 30) {
      errors.firstName = "First name cannot exceed 30 characters";
    }

    // Last Name (min 2, max 30 chars)
    if (!form.lastName.trim()) {
      errors.lastName = "Last name is required";
    } else if (form.lastName.length < 2) {
      errors.lastName = "Last name must be at least 2 characters";
    } else if (form.lastName.length > 30) {
      errors.lastName = "Last name cannot exceed 30 characters";
    }

    // Email (max 60 char)
    if (!form.email.trim()) {
      errors.email = "Email is required";
    } else if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(form.email)) {
      errors.email = "Enter a valid email address";
    } else if (form.email.length > 60) {
      errors.email = "Email cannot exceed 60 characters";
    }

    // Password (min 8, max 20 char, must contain uppercase + number)
    if (!form.password.trim()) {
      errors.password = "Password is required";
    } else if (form.password.length < 6) {
      errors.password = "Password must be at least 8 characters";
    } else if (form.password.length > 20) {
      errors.password = "Password cannot exceed 20 characters";
    } else if (!/[A-Z]/.test(form.password) || !/[0-9]/.test(form.password)) {
      errors.password = "Must contain at least 1 uppercase letter and 1 number";
    }

    // Confirm Password match
    if (!form.confirm_password.trim()) {
      errors.confirm_password = "Confirm password is required";
    } else if (form.password !== form.confirm_password) {
      errors.confirm_password = "Passwords do not match";
    }

    // Aadhaar (must be exactly 12 digits)
    if (!form.aadhaar.trim()) {
      errors.aadhaar = "Aadhaar number is required";
    } else if (!/^\d{12}$/.test(form.aadhaar)) {
      errors.aadhaar = "Aadhaar must be exactly 12 numeric digits";
    }

    // User Type (dropdown)
    if (!form.userType.trim()) {
      errors.userType = "User type is required";
    }

    return errors;
  };

  const handleCountryChange = (e) => {
    const country = countryID.find((c) => c.countryName === e.target.value);
    setSelectedCountry(country);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const {
      firstName,
      lastName,
      email,
      password,
      confirm_password,
      aadhaar,
      userType,
    } = form;

    const validationErrors = validateForm(form);
    console.log(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const fullNumber = phoneNumber.trim();
    const cleanedNumber = fullNumber.replace(/\D/g, "");

    const localNumber = cleanedNumber.startsWith(dialCode)
      ? cleanedNumber.slice(dialCode.length)
      : cleanedNumber;

    if (!localNumber) {
      toast.error("Please enter your phone number");
      return;
    }

    const isIndianNumber =
      dialCode === "91" && /^[6-9]\d{9}$/.test(localNumber);

    const isInternationalNumber =
      dialCode !== "91" && /^\d{8,15}$/.test(localNumber);

    if (!isIndianNumber && !isInternationalNumber) {
      toast.error(
        dialCode === "91"
          ? "Please enter a valid 10-digit Indian mobile number"
          : "Please enter a valid international phone number (8–15 digits)"
      );
      return;
    }

    // ------------------- PASSWORD MATCH -------------------
    if (password !== confirm_password) {
      toast.error("Passwords do not match");
      return;
    }

    // ------------------- AADHAAR VALIDATION -------------------
    if (userType === "CANDIDATE" && selectedCountry?.Length !== "N/A") {
      if (aadhaar.length !== Number(selectedCountry.Length)) {
        toast.error(
          `${selectedCountry.Id} must be ${selectedCountry.Length} digits`
        );
        return;
      }
    }

    // ------------------- SUCCESS → SUBMIT -------------------
    setErrors({});
    setLoading(true);

    try {
      if (userType === "VENDOR") {
        await dispatch(
          VendorRegister(
            firstName,
            lastName,
            email,
            password,
            localPhone,
            countryCode,
            selectedCountry.countryName,
            userType,
            aadhaar,
            dialCode
          )
        );

        toast.success("Registration Successful");
        navigate("/votp-verify", { state: { email, userType, logIn: false } });
      } else {
        await dispatch(
          register(
            firstName,
            lastName,
            email,
            password,
            localPhone,
            userType,
            countryCode,
            aadhaar,
            selectedCountry.countryName,
            dialCode
          )
        );

        toast.success("Registration Successful");
        navigate("/otp-verify", { state: { email, userType, logIn: false } });
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <header className="signin-header">
        <Link to="/" className="signin-logo-link">
          <motion.img
            src={logo}
            alt="eBench Logo"
            className="signin-logo"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
          />
        </Link>

        <Link to="/login" className="header-login-btn">
          Login
        </Link>
      </header>
      <div className="register-container">
        {/* LEFT SIDE */}
        <div className="register-left">
          <div className="overlay"></div>

          <div className="register-left-content">
            <div className="logo-box white-badge">
              <img src={ebenchLogo} alt="eBench Logo" />
            </div>

            <div className="welcome-text">
              <h1>
                Empowering Your <span className="accent">Career</span> &
                Business Growth
              </h1>
              <p>
                Discover a smarter way to connect candidates and vendors. With
                eBench, you can build your profile, manage opportunities, and
                collaborate on a global scale — all in one place.
              </p>

              {/* Highlights */}
              <div className="feature-highlights">
                <div className="feature-item">
                  <div className="icon">🌍</div>
                  <div className="text">Global talent and vendor network</div>
                </div>

                <div className="feature-item">
                  <div className="icon">⚙️</div>
                  <div className="text">Smart workflow automation tools</div>
                </div>

                <div className="feature-item">
                  <div className="icon">💡</div>
                  <div className="text">
                    Insightful analytics for better decisions
                  </div>
                </div>

                <div className="feature-item">
                  <div className="icon">🤝</div>
                  <div className="text">
                    Seamless collaboration between teams
                  </div>
                </div>
                <div className="feature-item">
                  <div className="icon">🚀</div>
                  <div className="text">
                    Accelerate hiring with AI-driven insights
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="register-right">
          <div className="register-card">
            <h1 className="form-title">Create Account</h1>
            <form onSubmit={handleSubmit}>
              {/* User Type */}
              {/* <div className="user-type-wrapper">
                <p className="user-type-label">Select User Type</p>
                <div className="user-type-selector">
                  {["CANDIDATE", "VENDOR"].map((type) => (
                    <label
                      key={type}
                      className={`type-option ${
                        form.userType === type ? "active" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="userType"
                        value={type}
                        checked={form.userType === type}
                        onChange={handleChange}
                      />
                      <span>
                        {type === "CANDIDATE" ? "Candidate" : "Vendor"}
                      </span>
                    </label>
                  ))}
                </div>
              </div> */}
              <div className="user-type-wrapper">
                <div className="user-type-header">
                  <p className="user-type-label">
                    <span className="label-decor"></span>
                    Register as
                  </p>
                </div>

                <div className="user-type-selector">
                  {["CANDIDATE", "VENDOR"].map((type) => (
                    <label
                      key={type}
                      className={`type-radio ${
                        form.userType === type ? "selected" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="userType"
                        value={type}
                        checked={form.userType === type}
                        onChange={handleChange}
                      />
                      <div className="radio-circle">
                        <div className="radio-inner" />
                      </div>
                      <span className="radio-label">
                        {type === "CANDIDATE" ? "Candidate" : "Vendor"}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Name */}
              <div className="two-input">
                <div className="field" style={{ width: "50%" }}>
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    value={form.firstName}
                    maxLength={30}
                    minLength={2}
                    onChange={handleChange}
                    required
                    className={errors.firstName ? "input-error" : ""}
                  />
                  {errors.firstName && (
                    <span className="error-text">{errors.firstName}</span>
                  )}
                </div>

                <div className="field" style={{ width: "50%" }}>
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    value={form.lastName}
                    maxLength={30}
                    minLength={2}
                    required
                    onChange={handleChange}
                    className={errors.lastName ? "input-error" : ""}
                  />
                  {errors.lastName && (
                    <span className="error-text">{errors.lastName}</span>
                  )}
                </div>
              </div>

              {/* Email */}
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={form.email}
                onChange={handleChange}
                required
              />
              {errors.email && <p className="error-text">{errors.email}</p>}

              {/* Passwords */}
              <div className="password-field">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  value={form.password}
                  onChange={handleChange}
                  required
                />
                <span onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <IoMdEyeOff /> : <IoMdEye />}
                </span>
              </div>

              {errors.password && (
                <p className="error-text">{errors.password}</p>
              )}

              <div className="password-field">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirm_password"
                  placeholder="Confirm Password"
                  value={form.confirm_password}
                  onChange={handleChange}
                  required
                />
                <span
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <IoMdEyeOff /> : <IoMdEye />}
                </span>
              </div>
              {errors.confirm_password && (
                <p className="error-text">{errors.confirm_password}</p>
              )}

              <div className="phone-field">
                <PhoneInput
                  country={countryCode || "in"}
                  value={phoneNumber}
                  onChange={(value, countryData) => {
                    const newDialCode = countryData?.dialCode || "";
                    const newCountryCode =
                      countryData?.countryCode?.toLowerCase() || "in";

                    setDialCode(newDialCode);
                    setCountryCode(newCountryCode);
                    setPhoneNumber(value);
                    const cleanedValue = value.replace(/\D/g, "");
                    const local = cleanedValue.startsWith(newDialCode)
                      ? cleanedValue.slice(newDialCode.length)
                      : cleanedValue;

                    setLocalPhone(local);
                  }}
                  placeholder="Phone Number"
                  enableSearch
                  inputClass="custom-phone-input"
                  buttonClass="custom-flag-btn"
                  dropdownClass="custom-country-dropdown"
                />

                {/* Validation message */}
                {dialCode === "91"
                  ? localPhone.length > 0 &&
                    localPhone.length < 10 && (
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          marginTop: "4px",
                          textAlign: "left",
                        }}
                      >
                        Enter a 10-digit mobile number.
                      </p>
                    )
                  : localPhone.length > 0 &&
                    localPhone.length < 7 && (
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          marginTop: "4px",
                          textAlign: "left",
                        }}
                      >
                        Enter a valid number (7–15 digits).
                      </p>
                    )}
              </div>

              <div>
                <select
                  value={selectedCountry.countryName}
                  onChange={handleCountryChange}
                  required
                >
                  <option value="">Select Country</option>
                  {countryID.map((c) => (
                    <option key={c.countryName} value={c.countryName}>
                      {c.countryName}
                    </option>
                  ))}
                </select>
              </div>

              {form.userType === "CANDIDATE" && selectedCountry.Id !== "ID" && (
                <input
                  type="text"
                  name="aadhaar"
                  placeholder={selectedCountry.Id}
                  value={form.aadhaar}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      aadhaar: e.target.value
                        .replace(/\D/g, "")
                        .slice(0, selectedCountry.Length),
                    }))
                  }
                  required
                />
              )}

              <button type="submit" className="submit-btn">
                {loading ? <SpinLoader /> : "Create Account"}
              </button>

              <p className="login-text">
                Already have an account?{" "}
                <Link to="/login" className="login-link">
                  Login
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Registration;
